/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

// NOTE: long names cause red screen.  eg: createPostRequest
// name the functions different than the constants, or the Saga will not be called
// An Offer is from a Vendor.  A Coupon is an Offer that has a User tied to it, and can be redeemed.

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  userCoupons:   [],
  redeemCoupon:  ["CouponId"],
  getOffer:      ["OfferId", "Code"],
  vendorOffers:  ["UserId"],
  getVendor:     ["UserId"],
  allOffers:     [],
  couponSuccess: ["kind", "changes"],
  couponFailure: ["kind", "changes"]
})

export const CouponTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  userCoupons: {
    phase: null, // loading, success, error
    error: null,
    logRef: null,    
    modified: null,
    list: [],
    byVendor: [],
    vendorNames: [],
  },
  redeemCoupon: {
    phase: null, // redeeming, success, error
    error: null,
    logRef: null,    
    modified: null,
    CouponId: null,
    record: null,
  },
  getOffer: {
    phase: null, // searching, success, error
    error: null,
    logRef: null,    
    modified: null,
    OfferId: null, // either by offerId OR
    Code: null, // by code
    record: null, // maybe field saying 'NoACharity' for display purposes
  },
  vendorOffers: {
    phase: null, // loading, success, error
    error: null,
    logRef: null,    
    modified: null,
    UserId: null,
    list: [],
  },
  getVendor: {
    phase: null, // loading, success, error
    error: null,
    logRef: null,    
    modified: null,
    UserId: null,
    record: null,
  },
  allOffers: {
    phase: null, // loading, success, error
    error: null,
    logRef: null,    
    modified: null,
    list: [],
  },
})

/* ------------- Reducers ------------- */

export const userCoupons = (state, action) => {
  console.tron.log(`CouponRedux couponList`);
  const userCoupons = Object.assign({}, state.userCoupons, {phase: 'loading', error: null, list: [], byVendor: [], vendorNames: []})
  return state.merge({ userCoupons })
}

export const redeemCoupon = (state, action) => {
  const { CouponId } = action
  console.tron.log(`CouponRedux couponRedeem ${CouponId}`);
  const redeemCoupon = Object.assign({}, state.redeemCoupon, {phase: 'redeeming', error: null, CouponId})
  return state.merge({ redeemCoupon })
}

export const getOffer = (state, action) => {
  const { OfferId = null, Code = null } = action
  console.tron.log(`CouponRedux getOffer OfferId: ${OfferId}, Code: ${Code}`);
  const getOffer = Object.assign({}, state.getOffer, {phase: 'loading', error: null, OfferId, Code, record: null})
  return state.merge({ getOffer })
}

export const vendorOffers = (state, action) => {
  const { UserId = null } = action
  console.tron.log(`CouponRedux vendorOffers`);
  const vendorOffers = Object.assign({}, state.vendorOffers, {phase: 'loading', error: null, UserId, list: []})
  return state.merge({ vendorOffers })
}

export const getVendor = (state, action) => {
  const { UserId = null } = action
  console.tron.log(`CouponRedux getVendor`);
  const getVendor = Object.assign({}, state.getVendor, {phase: 'loading', error: null, UserId, record: null})
  return state.merge({ getVendor })
}

export const allOffers = (state, action) => {
  console.tron.log(`CouponRedux offerFullList`);
  const allOffers = Object.assign({}, state.allOffers, {phase: 'loading', error: null, list: []})
  return state.merge({ allOffers })
}

const finalizeState = (state, action) => {
  console.tron.display({name: 'couponRedux', preview: 'finalizeState', value: { state, action }})
  switch (action.kind) {
    case 'userCoupons':
      return state.merge({userCoupons: Object.assign({}, state.userCoupons, action.changes)})
    case 'redeemCoupon':
      return state.merge({redeemCoupon: Object.assign({}, state.redeemCoupon, action.changes)})
    case 'getOffer':
      return state.merge({getOffer: Object.assign({}, state.getOffer, action.changes)})
    case 'vendorOffers':
      return state.merge({vendorOffers: Object.assign({}, state.vendorOffers, action.changes)})
    case 'getVendor':
      return state.merge({getVendor: Object.assign({}, state.getVendor, action.changes)})
    case 'allOffers':
      return state.merge({allOffers: Object.assign({}, state.allOffers, action.changes)})
    default:
      console.tron.log(`Error: unknown action.kind: ${action.kind}`)
  }
  return state.merge({})
}

export const couponSuccess = (state, action) => {
  return finalizeState(state, action)
}

export const couponFailure = (state, action) => {
  return finalizeState(state, action)
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.USER_COUPONS]:   userCoupons,
  [Types.REDEEM_COUPON]:  redeemCoupon,
  [Types.GET_OFFER]:      getOffer,
  [Types.VENDOR_OFFERS]:  vendorOffers,
  [Types.GET_VENDOR]:     getVendor,
  [Types.ALL_OFFERS]:     allOffers,
  [Types.COUPON_SUCCESS]: couponSuccess,
  [Types.COUPON_FAILURE]: couponFailure
})
